/**
 * Displays the notes at the bottom of a scorecard or initiative overview
 * screen, and handles the separator between the notes and the main content
 */
import $ from 'jquery'

import _ from 'lodash'
import DrawerLayout from 'scoreboard/components/drawer-layout'
import NotesView from 'scoreboard/notes/notes-view'
import permissions from 'scoreboard/components/permissions'
import appDisplay from 'scoreboard/components/app-display'
import ErrorView from 'scoreboard/components/error-view'
import i18n from 'scoreboard/components/i18n'
import constants from 'scoreboard/components/constants'

const NotesLayout = DrawerLayout.extend({
	initialize: function (options = {}) {
		DrawerLayout.prototype.initialize.apply(this, arguments)

		this.notes = new NotesView({ model: this.model })
		this.listenTo(this.notes, 'change:notes', () => this.renderDrawerContent())
		this.listenTo(this.model, 'change:notes', () => this.renderDrawerContent())
		// If there's no period display, add a class so styles can be adjusted
		options.noPeriodDisplay && this.$el.addClass('display-layout-no-period')
	},

	/**
	 * @override
	 */
	renderDrawerContent: function (container) {
		if (container) {
			container.append(this.notes.el)
		}

		this.notes.render()
		this.notes.$el.find('.note-preview:not(.add-note)').addClass('drawer-item')
		// resize AFTER changing the notes
		this.resize()
	},

	/**
	 * @override
	 */
	count: function () {
		var notes = this.model.get('notes')
		return notes ? notes.length : 0
	},

	/**
	 * @override
	 */
	 toggleDrawerOpen() {
		DrawerLayout.prototype.toggleDrawerOpen.apply(this, arguments)
		// This breaks encapulation, but tooltips which this class will be used to hide live
		// outside the .display-pane where this resides. This is a straight forward way
		// to hide them when the drawer is opened.
		$('body').toggleClass('drawer-layout-open', this._isOpen())
	},

	/**
	 * A way to programmatically launch a note and ensure the toggler is open.
	 * used when navigating from an alert about a note to the note.
	 *
	 * @param {Number} [options.id] the note id
	 * @param {Number} [options.replyId] ID of reply to edit - does nothing if !edit
	 * @param {'view' | 'edit' | 'new' | 'delete'} [options.noteAction] action to be taken in displaying note
	 */
	displayNote(options) {
		var noteAction = options.noteAction || 'view'
		if (options.id || noteAction === 'new' || noteAction === 'delete') {
			if (noteAction !== 'view' && !permissions.notes()) {
				// #28323 - for coming from shared dashboards when not logged in
				appDisplay.dialog(new ErrorView({
					title: 'admin.group.abilities.notesModify',
					messageCode: 'common.note.nopermission'
				}))
			} else {
				this.notes.displayNote(options.id, options.replyId, noteAction)
			}
		}
	},

	/**
	 * @override
	 */
	_updateHandleText() {
		if (this._isOpen()) {
			this._setHandleText(i18n.get('common.close'))
		} else {
			let hiddenNotes = this._getHiddenItems()
			let key = 'common.note.show'

			// If the drawer is not closed all the way, use the Show (x) more notes' verbage,
			// if it is all the way closed, keep the 'Show Notes (x)' verbage
			if (this.drawerContainer.height() > constants.DRAWER_CLOSED_HEIGHT) {
				key = 'scorecards.notes.more.'
				key += hiddenNotes == 1 ? 'singular' : 'plural'
			}

			this._setHandleText(i18n.get(key, hiddenNotes))
		}
	},

	remove: function() {
		$('body').removeClass('drawer-layout-open')
		DrawerLayout.prototype.remove.apply(this, arguments)
		_.invokeMap([this.notes], 'remove')
	}

})

export default NotesLayout

NotesLayout.__filename__ = 'notes/notes-layout.js'
